import React from "react";
import { ComingSoonText, ComingSoonWrapper, UfoImg } from "./styled";
import ufoSrc from "assets/images/ufo-wiener.png";
import { Flex } from "Element/Flex";
import { PrimaryButton } from "Element/Button";
import { useNavigate } from "react-router-dom";

const ComingSoon = () => {
  const nav = useNavigate();
  const handleBack = () => {
    nav(-1);
  };
  return (
    <>
      <ComingSoonWrapper>
        <Flex alignItems="center" justifyContent="center">
          <UfoImg src={ufoSrc} alt="" />
          <ComingSoonText>Coming Soon!</ComingSoonText>
          <UfoImg src={ufoSrc} alt="" />
        </Flex>
        <Flex>
          <PrimaryButton onClick={handleBack}>Go Back</PrimaryButton>
        </Flex>
      </ComingSoonWrapper>
    </>
  );
};

export default ComingSoon;
